import React, { useEffect } from "react";
import { useTranslation, withTranslation } from "react-i18next";

import * as util from "../../lib/common";

import { TaskSwitcherStatus, TaskSwitcherStatusType } from "@/models/tasks";

type Props = {
  value: TaskSwitcherStatusType;
  onChange: (_: TaskSwitcherStatusType) => void;
  ["data-test-id"]?: string;
};

const StatusSwitcher = ({ "data-test-id": dataTestId, ...props }: Props) => {
  const { t } = useTranslation();

  const [open, setOpen] = React.useState(false);

  const showDropdown = () => {
    setOpen(true);
  };

  const hideDropdown = () => {
    setOpen(false);
  };

  // 連続切替モードをESCキーで解除する
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        props.onChange(TaskSwitcherStatus.OFF);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const switcherStatusList = [
    { mark: "", label: `${t("status_change")} OFF`, value: TaskSwitcherStatus.OFF, testId: "none" },
    { mark: "ー", label: `（${t("no_process")}）`, value: TaskSwitcherStatus.NO_PROCESS, testId: "no-process" },
    { mark: "", label: `（${t("process_exist")}）`, value: TaskSwitcherStatus.YES_PROCESS, testId: "process" },
    { mark: "○", label: `（${t("schedule")}）`, value: TaskSwitcherStatus.SCHEDULE, testId: "schedule1" },
    { mark: "◎", label: `（${t("keep")}）`, value: TaskSwitcherStatus.CONTINUE, testId: "continue1" },
    { mark: "②", label: `（${t("schedule_two_days")}）`, value: TaskSwitcherStatus.SCHEDULE_2, testId: "schedule2" },
    { mark: "⓶", label: `（${t("continue_two_days")}）`, value: TaskSwitcherStatus.CONTINUE_2, testId: "continue2" },
    { mark: "③", label: `（${t("schedule_three_days")}）`, value: TaskSwitcherStatus.SCHEDULE_3, testId: "schedule3" },
    { mark: "⓷", label: `（${t("continue_three_days")}）`, value: TaskSwitcherStatus.CONTINUE_3, testId: "continue3" },
    { mark: "■", label: `（${t("completion_expected")}）`, value: TaskSwitcherStatus.COMPLETING, testId: "completing" },
    { mark: "△", label: `（${t("stop")}）`, value: TaskSwitcherStatus.INTERRUPT, testId: "interrupt" },
    { mark: "●", label: `（${t("completed")}）`, value: TaskSwitcherStatus.DONE, testId: "done" },
  ];

  return (
    <div className="btn-dropdown-area" onMouseLeave={() => hideDropdown()}>
      <button
        data-test-id={dataTestId}
        className={`btn btn-dropdown ${props.value === TaskSwitcherStatus.OFF ? "btn-gray" : "btn-blue"}`}
        onClick={showDropdown}
      >
        {t("status_change")}：
        {props.value === TaskSwitcherStatus.OFF ? (
          <span>OFF</span>
        ) : (
          <span className={props.value === TaskSwitcherStatus.YES_PROCESS ? "symbol-empty is-selected" : "status-mark"}>
            {util.getStatusText(props.value)}
          </span>
        )}
      </button>
      {open && (
        <ul className="dropdown-menu" onClick={() => hideDropdown()}>
          {switcherStatusList.map((item, index) => {
            if (props.value === item.value) {
              return null;
            }

            return (
              <li
                key={index}
                onClick={() => props.onChange(item.value)}
                data-test-id={dataTestId ? `${dataTestId}-${item.testId}` : undefined}
              >
                <span
                  className={item.value === TaskSwitcherStatus.YES_PROCESS ? "symbol-empty" : ""}
                  style={{ display: "flex" }}
                >
                  {item.mark && <span className="status-mark">{item.mark}</span>}
                  {item.label}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default withTranslation()(StatusSwitcher);
